import React from 'react'
import './index.scss'

export default () => <button className="btn">hover me</button>
